export const lightTheme = {
  menu: {
    primaryTextColor: "rgba(56, 55, 69, 1)",
    secondaryTextColor: "rgba(79, 78, 94, 1)",
    background: "rgba(248, 250, 251, 1)",
    groupContentBackground: "rgba(240, 242, 255, 1)",
    deleteColor: "rgba(238, 80, 80, 1)",
    version: "rgba(150, 156, 161, 0.8)",
    infoText: "rgba(135, 140, 145, 1)",
    selectedTextColor: "rgba(112, 105, 253, 1)",
    selectedOpionBackground: "rgba(225, 224, 250, 1)",
    loadingIndicator: "rgba(112, 105, 253, 1)",
    enterPhoneNumberBackground: "rgba(233, 235, 250, 1)",
    avatarBackground: "rgba(163, 167, 176, 1)",
    toggleFadedColor: "rgba(79, 78, 94, 0.5)",
  },

  chat: {
    selectedBackground: "rgba(223, 229, 242, 1)",
    elementSecondaryColor: "rgba(150, 156, 161, 1)",
    receivedMessageBackground: "rgba(112, 105, 253, 1)",
    sentMessageBackground: "rgba(225, 225, 239, 1)",
    sentMessageTextColor: "rgba(94, 78, 78, 1)",
    receivedMessageTextColor: "rgba(255, 255, 255, 1)",
    sentTime: "rgba(79, 78, 94, 0.8)",
    readIconColor: "rgba(112, 105, 253, 1)",
    conversationBackground: "rgba(255, 255, 255, 1)",
    conversationHeader: "rgba(248, 250, 251, 1)",
    sendBtn: "rgba(112, 105, 253, 1)",
    sendBtnBorder: "rgba(215, 214, 238, 1)",
    mediaBtnBackground: "rgba(225, 224, 250, 1)",
    mediaBtnBorder: "rgba(215, 214, 238, 1)",
    mediaBtnColor: "rgba(112, 105, 253, 1)",
    messageInputTextColor: "rgba(94, 78, 78, 1)",
    messageInputBackground: "rgba(255, 255, 255, 1)",
    messageInputWrapperBackground: "rgba(248, 250, 251, 1)",
    dateSeparatorLine: "rgba(225, 225, 239, 1)",
    dateSeparatorColor: "rgba(150, 156, 161, 1)",
    translationMessageTextColor: "rgba(161, 159, 185, 1)",
    translationMessageTextColorReceived: "rgba(255, 255, 255,0.7)",
    translationMessageBorderColor: "rgba(161, 159, 185, 0.15)",
    replyElementBgReceived: "rgba(75, 73, 115, 1)",
    replyElementBgSent: "#5A54CC",
  },

  call: {
    callElementSelectedBackground: "rgba(223, 229, 242, 1)",
    callElementBackground: "rgba(248, 250, 251, 1)",
    selectedBackground: "rgba(223, 229, 242, 1)",
    elementSecondaryColor: "rgba(150, 156, 161, 1)",
    receivedMessageBackground: "rgba(112, 105, 253, 1)",
    sentMessageBackground: "rgba(225, 225, 239, 1)",
    sentMessageTextColor: "rgba(94, 78, 78, 1)",
    receivedMessageTextColor: "rgba(255, 255, 255, 1)",
    sentTime: "rgba(79, 78, 94, 0.8)",
    readIconColor: "rgba(112, 105, 253, 1)",
    conversationBackground: "rgba(255, 255, 255, 1)",
    conversationHeader: "rgba(248, 250, 251, 1)",
    sendBtn: "rgba(112, 105, 253, 1)",
    sendBtnBorder: "rgba(215, 214, 238, 1)",
    mediaBtnBackground: "rgba(225, 224, 250, 1)",
    mediaBtnBorder: "rgba(215, 214, 238, 1)",
    mediaBtnColor: "rgba(112, 105, 253, 1)",
    messageInputTextColor: "rgba(94, 78, 78, 1)",
    messageInputBackground: "rgba(255, 255, 255, 1)",
    messageInputWrapperBackground: "rgba(248, 250, 251, 1)",
    dateSeparatorLine: "rgba(225, 225, 239, 1)",
    dateSeparatorColor: "rgba(150, 156, 161, 1)",
    translationMessageBorderColor: "rgba(161, 159, 185, 0.15)",
  },

  sidebar: {
    background: "rgba(245, 247, 251, 1)",
    iconColor: "rgba(132, 137, 146, 1)",
    selectedIconColor: "rgba(112, 105, 253, 1)",
    selectedBtnTextColor: "rgba(56, 55, 69, 1)",
    selectedBtnBackground: "rgba(225, 224, 250, 1)",
    avatarBorderColor: "rgba(220, 227, 236, 1)",
    borderColor: "rgba(215, 214, 238, 1)",
  },

  primaryButton: {
    background: "rgba(243, 240, 255,1)",
    borderColor: "rgba(112, 105, 253, 1)",
    color: "rgb(116, 108, 255)",
    removeBackground: "rgba(241, 124, 124,0.1)",
  },

  toggleButton: {
    borderColor: "rgba(112, 105, 253, 0.5)",
  },

  loginButton: {
    background: "rgba(82, 91, 183, 1)",
    borderColor: "rgba(75, 73, 115, 1)",
    color: "rgba(255, 255, 255, 1)",
  },

  callComponent: {
    participantsListBackground: "rgba(240, 242, 255, 1)",
    participantComponentBackground: "rgba(225, 225, 239, 1)",
    speakingBorder: "rgba(112, 105, 253, 1)",
    controlButtonTextColor: "rgba(79, 78, 94, 1)",

    controlButtonBackgroundActive: "rgba(225, 224, 250, 1)",
    controlButtonIconActive: "rgba(24, 29, 36, 1)",

    controlButtonBackgroundInactive: "rgba(223, 229, 242, 1)",
    controlButtonIconInactive: "rgba(24, 29, 36, 1)",
    translationModeBg: "rgba(223, 229, 242, 1)",
    translationModeButtonBt: "rgba(240, 242, 255, 1)",
    speakingLabelBg: "rgba(111, 105, 255, 0.6)"
  },

  meetingComponent: {
    meetingElementBackground: "rgba(31, 36, 48, 1)",
    ongoingMeetingElementBackground: "rgba(215, 214, 238, 1)",
    meetingJoinBackground: "#F0F2FE",
  },

  check: {
    background: "rgba(146, 139, 237, 1)",
    border: "rgba(215, 214, 238, 1)",
    checkSign: "rgba(255, 255, 255, 1)",
  },

  unreadCounter: {
    color: "rgba(255, 255, 255, 1)",
  },

  finishSpeakBtn: {
    background: "rgba(24, 29, 36, 1)",
    color: "rgba(223, 229, 242, 1)",
  },
  listenerWrapper: {
    background: "rgba(215, 214, 238, 1)",
    color: "rgba(146, 139, 237, 1)",
  },
  moodIcon: {
    background: "rgba(225, 224, 250, 1)",
    backgroundSelected: "rgba(146, 139, 237, 1)",
    color: "rgba(146, 139, 237, 1)",
    colorSelected: "rgba(255, 255, 255, 1)",
  },

  planPicker: {
    selectorColor: "rgba(225, 224, 250, 1)",
    unCheckedColor: "rgb(212, 209, 212)",
  },
  first_time_message: {
    background: "rgba(240, 242, 255, 1)",
  },

  premium_green: "#11B973",
  valid_green: "rgba(112, 203, 151, 1)",
};
